/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesSubnetsSubnetIdPngRequest = {
  subnetId: string;
};

/** @internal */
export const GetApiV3ImagesSubnetsSubnetIdPngRequest$inboundSchema: z.ZodType<
  GetApiV3ImagesSubnetsSubnetIdPngRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  subnet_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "subnet_id": "subnetId",
  });
});

/** @internal */
export type GetApiV3ImagesSubnetsSubnetIdPngRequest$Outbound = {
  subnet_id: string;
};

/** @internal */
export const GetApiV3ImagesSubnetsSubnetIdPngRequest$outboundSchema: z.ZodType<
  GetApiV3ImagesSubnetsSubnetIdPngRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ImagesSubnetsSubnetIdPngRequest
> = z.object({
  subnetId: z.string(),
}).transform((v) => {
  return remap$(v, {
    subnetId: "subnet_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesSubnetsSubnetIdPngRequest$ {
  /** @deprecated use `GetApiV3ImagesSubnetsSubnetIdPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesSubnetsSubnetIdPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesSubnetsSubnetIdPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesSubnetsSubnetIdPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesSubnetsSubnetIdPngRequest$Outbound` instead. */
  export type Outbound = GetApiV3ImagesSubnetsSubnetIdPngRequest$Outbound;
}

export function getApiV3ImagesSubnetsSubnetIdPngRequestToJSON(
  getApiV3ImagesSubnetsSubnetIdPngRequest:
    GetApiV3ImagesSubnetsSubnetIdPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesSubnetsSubnetIdPngRequest$outboundSchema.parse(
      getApiV3ImagesSubnetsSubnetIdPngRequest,
    ),
  );
}

export function getApiV3ImagesSubnetsSubnetIdPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ImagesSubnetsSubnetIdPngRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesSubnetsSubnetIdPngRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ImagesSubnetsSubnetIdPngRequest' from JSON`,
  );
}
